import styled from 'styled-components'
import {rem} from '../../styles/functions.styled'
import {Settings} from '../../styles/settings.styled'
import {Colors} from '../../styles/colors.styled'
import {FontWeight} from '../../styles/typography.styled'
import BackgroundImageSrc from '../../assets/images/quiosco-bg-01.jpg'

export const Page = styled.section`
`

export const Background = styled.div`
  display: flex;
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: -1;
`

export const BackgroundImage = styled.figure`
  background-image: url(${BackgroundImageSrc});
  background-repeat: no-repeat;
  background-size: cover;
  flex: 1;
  margin: 0;
  padding: 0;
`

export const Card = styled.div`
  background-color: rgba(0, 51, 102, 0.6);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  //display: flex;
  //gap: 30px;
  text-align: center;
  //margin-bottom: 50px;
  padding: 30px;
  
  h1 {
    //background-color: ${Colors.primary};
    color: white;
    font-size: ${rem(48)};
    margin: 0 0 20px 0;
    padding: 5px 20px;
  }
`

export const Content = styled.div`
  height: 100vh;
  justify-content: center;
`

export const FieldGroup = styled.div`
  // align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 30px;
  
  label {
    //background-color: ${Colors.primary};
    color: white;
    display: inline-block;
    font-size: ${rem(34)};
    font-weight: ${FontWeight.medium};
    margin-bottom: 10px;
    padding: 5px 20px;
  }
  
  input {
    border: none;
    border-radius: ${Settings.border_radius}px;
    font-size: ${rem(34)};
    font-weight: ${FontWeight.medium};
    padding: 26px;
    text-align: center;
    width: auto;
    
    &:focus {
      outline: none;
    }
  }
  select {
    border: none;
    border-radius: ${Settings.border_radius}px;
    font-size: ${rem(34)};
    font-weight: ${FontWeight.medium};
    padding: 26px;
    text-align: center;
    width: auto;
    background-color: white; /* Mantener fondo blanco */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url('data:image/svg+xml;utf8,<svg fill="black" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
    background-repeat: no-repeat;
    background-position: right 20px center;
    background-size: 48px 48px;
    padding-right: 70px; /* Espacio para la flecha */
    
    &:focus {
      outline: none;
    }
  }
`

export const FieldGroupContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
`

export const LoginForm = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
`

export const Top = styled.div`
  text-align: center;
`

/** Botón debug: solo visible en Electron; esquina inferior izquierda. */
export const DevToolsToggle = styled.button`
  position: fixed;
  bottom: 10px;
  left: 10px;
  z-index: 20;
  margin: 0;
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.35);
  font-size: ${rem(14)};
  font-weight: ${FontWeight.medium};
  letter-spacing: 0.04em;
  cursor: pointer;
  user-select: none;

  &:active {
    color: rgba(255, 255, 255, 0.7);
    background: rgba(0, 0, 0, 0.3);
  }
`